import React, { Component } from 'react';


export class SimpleFrame extends Component {

  render() {
    const title = typeof this.props.title === 'string' ? <h2>{ this.props.title }</h2> :
      ( this.props.title ? this.props.title : null );

    const {
      tag: Tag,
      color
    } = this.props;

    const footer = this.props.footer || null;

    return (
      <Tag className={ this.props.windowClass || "simple-frame" } style={{ backgroundColor: color }}>
        { title }
        { typeof this.props.subtitle === 'string' && <p>{ this.props.subtitle }</p> }
        <div className="mt-4">
          { this.props.children }
        </div>
        { footer }
      </Tag>
    );
  }
}

SimpleFrame.defaultProps = {
  tag: 'div',
  color: 'transparent'
};



// WEBPACK FOOTER //
// ./src/frame/SimpleFrame.js